import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Histórico ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlbumsOutline = _resolveComponent("AlbumsOutline")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_spin = _resolveComponent("n-spin")!
  const _component_n_data_table = _resolveComponent("n-data-table")!
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_n_button, {
      onClick: _ctx.openModal,
      type: "info",
      size: "small"
    }, {
      icon: _withCtx(() => [
        _createVNode(_component_n_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_AlbumsOutline)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_n_modal, {
      show: _ctx.showModal,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showModal) = $event)),
      "mask-closable": false,
      class: "w-full md:w-1/2",
      preset: "card",
      title: `Informações do grupo ${_ctx.grupo.titulo}`
    }, {
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_n_spin, { key: 0 }))
          : (_openBlock(), _createBlock(_component_n_data_table, {
              key: 1,
              columns: _ctx.columns,
              data: _ctx.historics,
              pagination: _ctx.pagination,
              bordered: false,
              "max-height": 250
            }, null, 8, ["columns", "data", "pagination"]))
      ]),
      _: 1
    }, 8, ["show", "title"])
  ], 64))
}